import { useMemo, type FC } from 'react';
import { StyleSheet } from 'react-native';
import { ActivityIndicator, FAB } from 'react-native-paper';

import { ArrowForwardIcon, AddIcon } from '@/assets';
import { useAppTheme } from '@/styles/hooks/useAppTheme';

const makeStyles = () =>
  StyleSheet.create({
    fab: {
      position: 'absolute',
      margin: 16,
      bottom: 0,
      alignSelf: 'center'
    }
  });

type FloatingActionButtonProps = {
  // Pass bottom if component is used without tab bar, e.g. groups
  bottom?: number;
  onPress: () => void;
  isDisabled?: boolean;
  isLoading?: boolean;
  label?: string;
  testID?: string;
};

export const FloatingActionButton: FC<FloatingActionButtonProps> = ({
  bottom = 0,
  onPress,
  isDisabled,
  isLoading,
  label,
  testID
}) => {
  const theme = useAppTheme();
  const styles = useMemo(() => makeStyles(), []);

  return (
    <FAB
      animated={false}
      testID={testID}
      icon={({ color, size }) => {
        if (isLoading) return <ActivityIndicator color={color} />;
        else
          return label ? (
            <ArrowForwardIcon fill={color} height={size} width={size} />
          ) : (
            <AddIcon fill={color} height={size} width={size} />
          );
      }}
      style={[
        styles.fab,
        { marginBottom: 16 + bottom },
        label ? {} : { borderRadius: 28 },
        isDisabled
          ? { backgroundColor: theme.colors.surfaceVariant }
          : { backgroundColor: theme.colors.error }
      ]}
      color={theme.colors.onPrimary}
      onPress={onPress}
      label={label}
      disabled={isDisabled}
    />
  );
};
